import styled from 'styled-components';

export const InfoSectionStyled = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  position: relative;
  z-index: 2;

  @media (min-width: 1440px) {
    flex-grow: 1;
    margin-bottom: 20px;
  }

  .card-holder {
    @media (min-width: 768px) {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 16px;
    }

    @media (min-width: 992px) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media (min-width: 1440px) {
      flex-grow: 1;
      gap: 24px;
    }
  }

  .custom-modal-overlay {
    position: fixed;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: fadeIn 0.25s ease-in-out;
    background: rgba(50, 59, 75, 0.1);
    backdrop-filter: blur(4px);
    z-index: 999;
  }

  .custom-modal-box {
    position: relative;
    background: #fff;
    width: 900px;
    max-width: 95%;
    max-height: 90vh;
    border-radius: 20px;
    padding: 40px 0 0;
    animation: scaleUp 0.25s ease-in-out;
    overflow-y: auto;
    box-shadow: 20px 20px 20px 0px rgba(0, 0, 0, 0.05);
  }

  .custom-modal-close {
    position: absolute;
    top: 8px;
    right: 15px;
    font-size: 28px;
    color: #bdbdbd;
    background: transparent;
    border: none;
    cursor: pointer;
    line-height: 1;
    transition: transform 0.2s ease;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes scaleUp {
    from {
      transform: scale(0.95);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }
`;

export const CardBoxStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 15px;
  border-radius: 16px;
  background: var(--white);
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.15);

  &:not(:last-child) {
    margin: 0 0 15px;

    @media (min-width: 768px) {
      margin: 0;
    }
  }

  @media (min-width: 1440px) {
    padding: 18px 24px;
  }

  .img-box {
    flex-shrink: 0;
    width: 50px;
    height: 50px;

    @media (min-width: 1440px) {
      width: 90px;
      height: 90px;
    }
  }

  .text-box {
    flex-grow: 1;
    font-size: 12px;
    line-height: 15px;
    padding: 0 15px 0 0;
  }

  .title {
    display: block;
    font-size: 15px;
    line-height: 18px;
    font-weight: 500;
    margin: 0 0 10px;
    color: var(--primary);

    @media (min-width: 1200px) {
      font-size: 18px;
      line-height: 22px;
    }
    @media (min-width: 1440px) {
      font-size: 20px;
      line-height: 23px;
    }
  }

  p {
    margin: 0 0 15px;
  }

  .btn {
    display: inline-block;
    vertical-align: top;
    min-width: 120px;
    font-size: 12px;
    line-height: 16px;
    text-transform: capitalize;
    font-weight: 500;
    border: 0;
    padding: 12px 10px;
    border-radius: 50px;
    color: var(--white);
    background: var(--blue);

    @media (min-width: 1440px) {
      min-width: 152px;
      /* font-size: 14px;
      line-height: 18px; */
    }
  }
`;

export const ModalStyles = styled.div`
  position: relative;

  .holder {
    max-width: 800px;
    margin: 0 auto;
    padding: 0 15px;
  }

  .header {
    width: 100%;
    font-size: 16px;
    line-height: 20px;
    margin: 0 0 20px;
    color: #9d9d9d;

    .title {
      display: block;
      font-size: 22px;
      line-height: 25px;
      font-weight: 500;
      margin: 0 0 5px;
      color: #313131;
    }
  }

  .item-wrap {
    width: 100%;
    margin: 0 0 70px;
  }

  .radio-custom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row-reverse;
    gap: 10px;
    width: 100%;
    font-size: 16px;
    line-height: 19px;
    color: var(--black);
    margin: 0 0 16px;
    position: relative;

    input {
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);

      &:checked ~ {
        .radio-text {
          border: 1px solid rgba(49, 123, 255, 0.1);
          background: rgba(49, 123, 255, 0.1);
        }
      }
    }

    .radio-text {
      display: flex;
      align-items: center;
      gap: 10px;
      flex-grow: 1;
      cursor: pointer;
      min-height: 80px;
      padding: 15px;
      border-radius: 20px;
      border: 1px solid #e2e2e2;
      background: #fafafa;
    }
  }

  .btn-holder {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 15px;
    width: 100%;
    padding: 20px;
    border-top: 1px solid #e6e7ec;
  }
`;
